import Vue from 'vue'

export default {
  getDisplayCateData: state => {
    return state.displayCateData
  },
  getDisplayCateDataCnt: state => {
    return state.displayCateData.length
  },
  getDisplayData: state => {
    return state.displayData
  },
  getDisplayPage: state => {
    return state.displayPage
  },
  isExistDisplayPage: state => page => {
    return state.displayPage.includes(page)
  },
  isUpdatedDisplayData: state => {
    return state.isUpdatedDisplayData
  },
  getDisplayDataCnt: state => {
    return state.displayData.length
  },
  getDisplayDataFromDB: (state, context) => payload => {
    if (!context.isExistDisplayPage(payload.page)) {
      let params = {
        params: {
          access: payload.access,
          page: payload.page
        }
      }
      const action = '/displays'
      // console.log(this.$store.getters.getDisplayPage)
      vm.$store.dispatch('setDisplayPage', payload.page).then(() => {
        vm.$axios.get(action, params).then((rs) => {
          vm.$store.dispatch('setDisplayData', rs.data)
        })
      })
    }
  },
  isExistListOfCalledAPI: state => {
    const rtn = api => state.listOfCalledAPI.indexOf(api) > -1
    return rtn
  },
  getVideoData: state => {
    return state.videoData
  },
  isExistVideoData: state => payload => {
    return Object.keys(state.videoData).length > 0 && state.videoData.p === payload.p
  },
  getGorillaChartData: state => {
    return state.gorillaChartData
  },
  getGorillaChartTopCnt: state => {
    return state.gorillaChartData.length
  },
  getGorillaChartWithKey: state => payload => {
    return state.gorillaChartData[payload]
  },
  getGorillaChartWithKeyCnt: state => payload => {
    return state.gorillaChartData[payload] && state.gorillaChartData[payload].length > 0
  },
  getCardCorpData: state => {
    return state.cardCorpData
  },
  getCardCorpDataCnt: state => {
    return state.cardCorpData.length
  },
  getCardCorpEventData: state => {
    return state.cardCorpEventData
  },
  getCardCorpEventDataCnt: state => {
    return state.cardCorpEventData.length
  },
  getCardDataForSearch: state => payload => {
    return payload ? state.cardDataForSearch[payload] : []
  },
  getCardDataForSearchCnt: state => payload => {
    return payload && state.cardDataForSearch[payload] ? state.cardDataForSearch[payload].length : 0
  },
  getCardDataQueryAndResult: state => {
    return state.cardDataQueryAndResult
  },
  getBenefitDataDepth: state => {
    return state.benefitDataDepth
  },
  getBenefitDataDepthCnt: state => {
    return state.benefitDataDepth.length
  },
  getBenefitDataFlat: state => {
    return state.benefitDataFlat
  },
  getBenefitDataFlatCnt: state => {
    return state.benefitDataFlat.length
  },
  getCardCoverData: state => {
    return state.cardCoverData
  },
  getCardCoverDataCnt: state => {
    return state.cardCoverData.length
  },
  isOpenCompareSlot: state => {
    return state.openCompareSlot
  },
  isCompareSlotBigSize: state => {
    return state.bigCompareSlot
  },
  isToastBannerSmallSize: state => {
    return state.smallToastBanner
  },
  getCompareSlotBigSizePosition: state => {
    return state.bigCompareSlotPosition
  },
  getCompareSlotData: state => {
    if (Object.keys(state.compareSlotData).length === 0) {
      const data = Vue.localStorage.get('compareSlotData')
      if (data && data.length > 0) {
        const compareSlotData = JSON.parse(Vue.localStorage.get('compareSlotData'))
        if (compareSlotData) vm.$store.dispatch('setCompareSlotData', compareSlotData)
      }
    }
    return state.compareSlotData
  },
  getCompareRcmdModal: state => {
    return state.compareRcmdModal
  },
  getCurrentChartTitle: state => {
    return state.currentChartTitle
  },
  isOpenAllChartDialog: (state) => {
    return state.openAllChartDialog
  },
  isOpenAwd1Dialog: (state) => {
    return state.openAwd1Dialog
  },
  isOpenAwd2Dialog: (state) => {
    return state.openAwd2Dialog
  },
  isOpenAwd3Dialog: (state) => {
    return state.openAwd3Dialog
  },
  isOpenAwd4Dialog: (state) => {
    return state.openAwd4Dialog
  },
  isOpenAwd5Dialog: (state) => {
    return state.openAwd5Dialog
  },
	isOpenSpe1Dialog: (state) => {
    return state.openSpe1Dialog
  },
	isOpenSpe2Dialog: (state) => {
    return state.openSpe2Dialog
  },
	isOpenSpe3Dialog: (state) => {
    return state.openSpe3Dialog
  },
	isOpenSpe4Dialog: (state) => {
    return state.openSpe4Dialog
  },
	isOpenReturn1Dialog: (state) => {
    return state.openReturn1Dialog
  },
	isOpenReturn2Dialog: (state) => {
    return state.openReturn2Dialog
  },
	isOpenReturn3Dialog: (state) => {
    return state.openReturn3Dialog
  },
	isOpenReturn4Dialog: (state) => {
    return state.openReturn4Dialog
  },
	isOpenCheckDialog: (state) => {
    return state.openCheckDialog
  },
	isOpenBrandDialog: (state) => {
    return state.openBrandDialog
  },
  isOpenKBcorpDialog: (state) => {
    return state.openKBcorpDialog
  },
	isOpenShareDialog: (state) => {
		return state.openShareDialog
	},
	isOpenShare2Dialog: (state) => {
		return state.openShare2Dialog
	},
	isOpenFaqDialog: (state) => {
		return state.openFaqDialog
	},
	isOpenFooterDialog: (state) => {
		return state.openFooterDialog
	},
	isOpenShorts1Dialog: (state) => {
		return state.openShorts1Dialog
	},
	isOpenShorts2Dialog: (state) => {
		return state.openShorts2Dialog
	},
	isOpenShorts3Dialog: (state) => {
		return state.openShorts3Dialog
	},
	isOpenShorts4Dialog: (state) => {
		return state.openShorts4Dialog
	},
	isOpenShorts5Dialog: (state) => {
		return state.openShorts5Dialog
	},
  getCurrentTeamName: state => {
    return state.currentTeam.name ? state.currentTeam.name : ''
  },
  getCurrentTeamNameEng: state => {
    return state.currentTeam.name_eng ? state.currentTeam.name_eng : ''
  },
  getCurrentTeamIdx: state => {
    return state.currentTeam.idx ? state.currentTeam.idx : Number(vm.$route.params.idx)
  },
  getCurrentCalendarLabel: state => {
    return state.currentCalendarLabel
  },
  getCurrentTeamChartData: state => payload => {
    return payload ? state.currentTeamChartData[payload] : state.currentTeamChartData
  },
  getCurrentTeamCardData: state => payload => {
    return payload && state.currentTeamCardData[payload] ? state.currentTeamCardData[payload] : {page: 1, data: [], finished: false}
  },
  getCurrentTeamEventData: state => payload => {
    return payload && state.currentTeamEventData[payload] ? state.currentTeamEventData[payload] : null
  },
  getCurrentEventData: state => payload => {
    return payload && state.currentEventData[payload] ? state.currentEventData[payload] : null
  },
  isOpenTeamDropdown: state => {
    return state.openTeamDropdown
  },
  getCurrentContentsData: state => {
    return state.currentContentsData
  },
  isOpenCalendarDialog: (state) => {
    return state.openCalendarDialog
  },
  getCurrentCard: (state) => {
    return state.currentCard
  },
  getSlotIndex: (state) => {
    return state.slotIndex
  },
  getFroalaAlertText: (state) => {
    return state.froalaAlertText
  },
  isEventLayerOpen: state => {
    return state.eventLayerOpen
  },
  getEventLayerDetail: state => {
    return state.eventLayerDetail
  },
}
